import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

function initColumns() {
    const parents = document.querySelectorAll('.js-grid:not(:has(.text-quote))')

    let mm = gsap.matchMedia()

    mm.add('(min-width: 1024px)', () => {
        parents.forEach((p) => {
            const children = gsap.utils.toArray(p.children)
            const played = children.map(() => false)
            const thresholds = children.map(
                (_, i) => i / Math.max(children.length, 1)
            )

            const tweens = children.map((c) => {
                const hasClipReveal = c.matches(':has(.clip-reveal)')

                if (hasClipReveal) {
                    gsap.set(c, {
                        clipPath: 'inset(0 0 100% 0)',
                        WebkitClipPath: 'inset(0 0 100% 0)'
                    })
                    return gsap.fromTo(
                        c,
                        {
                            clipPath: 'inset(0 0 100% 0)',
                            WebkitClipPath: 'inset(0 0 100% 0)'
                        },
                        {
                            clipPath: 'inset(0 0 0% 0)',
                            WebkitClipPath: 'inset(0 0 0% 0)',
                            duration: 1,
                            ease: 'power3.inOut',
                            paused: true,
                            immediateRender: false
                        }
                    )
                }

                gsap.set(c, { opacity: 0 })
                return gsap.fromTo(
                    c,
                    {
                        opacity: 0
                    },
                    {
                        opacity: 1,
                        duration: 0.5,
                        ease: 'power3.inOut',
                        paused: true,
                        immediateRender: false
                    }
                )
            })

            ScrollTrigger.create({
                trigger: p,
                start: 'top 80% ',
                // end: '+=',
                end: `+=${(window.innerHeight / 100) * 50}`,
                scrub: true,
                onUpdate: (self) => {
                    const progress = self.progress
                    tweens.forEach((tween, i) => {
                        if (!played[i] && progress >= thresholds[i]) {
                            played[i] = true
                            tween.play()
                        }
                    })
                }
                // markers: true
            })
        })

        return () => {
            // optional
            // custom cleanup code here (runs when it STOPS matching)
        }
    })

    mm.add('(max-width: 1023px)', () => {
        parents.forEach((p) => {
            const children = gsap.utils.toArray(p.children)

            children.forEach((c) => {
                const hasClipReveal = c.matches(':has(.clip-reveal)')
                // const hasQuote = c.matches(':has(.text-quote)')

                if (hasClipReveal) {
                    gsap.fromTo(
                        c,
                        {
                            clipPath: 'inset(0 0 100% 0)',
                            WebkitClipPath: 'inset(0 0 100% 0)'
                        },
                        {
                            scrollTrigger: {
                                trigger: c,

                                start: 'top 80% '
                            },
                            clipPath: 'inset(0 0 0% 0)',
                            WebkitClipPath: 'inset(0 0 0% 0)',
                            duration: 1,
                            ease: 'power3.inOut'
                        }
                    )
                    return
                }

                gsap.fromTo(
                    c,
                    {
                        opacity: 0
                    },
                    {
                        scrollTrigger: {
                            trigger: c,
                            start: 'top 80% '
                        },
                        opacity: 1,
                        duration: 1,
                        ease: 'power3.inOut'
                    }
                )
            })
        })

        return () => {
            // optional
            // custom cleanup code here (runs when it STOPS matching)
        }
    })

    // elements.forEach((el) => {
    //     gsap.fromTo(
    //         el,
    //         {
    //             clipPath: 'inset(0 0 100% 0)',
    //             WebkitClipPath: 'inset(0 0 100% 0)'
    //         },
    //         {
    //             clipPath: 'inset(0 0 0% 0)',
    //             WebkitClipPath: 'inset(0 0 0% 0)',
    //             duration: 0.9,
    //             ease: 'power2.out',
    //             scrollTrigger: {
    //                 trigger: el,
    //                 start: el.dataset.start || 'top 80%',
    //                 once: true
    //                 // markers: true,
    //             }
    //         }
    //     )
    // })
}

document.addEventListener('DOMContentLoaded', () => {
    initColumns()
})
